/*
 * @Description: 登陆日志store
 * @Author: wangzhenxin (834529118@qq.com)
 * @Date: 2019-05-30 15:24:39
 * @LastEditTime: 2020-10-29 14:11:09
 * @LastEditors:   YOYO [792611446@qq.com]
 */
import { getList, deletesLoginLog } from './service'

function getParams (state) {
  const {
    pagination: { pageIndex, pageSize },
    search,
  } = state

  const params = Object.entries(search).reduce(
    (prev, [key, value]) => (value ? { ...prev, [key]: value } : prev),
    { pageIndex, pageSize }
  )

  return params
}

function getInitData () {
  return {
    list: [],
    // 分页数据
    pagination: {
      // 一共多少页
      pageCount: 1,
      // 第几页
      pageIndex: 1,
      // 一页显示多少个
      pageSize: 10,
      // 总个数
      total: 1,
    },
    // 搜索数据
    search: {
      beginTime: '',
      endTime: '',
      realname: '',
      sort: '',
    },
  }
}

const state = {
  ...getInitData(),
}

const mutations = {
  setState (state, payload) {
    Object.assign(state, payload)
  },
  setPagination (state, payload) {
    state.pagination = { ...state.pagination, ...payload }
  },
  setSearch (state, payload) {
    state.search = { ...state.search, ...payload }
  },
  restState (state) {
    Object.assign(state, getInitData())
  },
}

const actions = {
  getListBySearchBtn ({ state, commit, dispatch }) {
    commit('setPagination', { ...state.pagination, pageIndex: 1 })

    return dispatch('getList')
  },
  async getList ({ state, commit, dispatch }) {
    const params = getParams(state)

    const res = await getList(params)

    if (res.code === 'success') {
      const { list, total, pageIndex } = res.data
      const { pageSize } = state.pagination

      const count = Math.ceil(total / pageSize)

      const index = count > pageIndex ? pageIndex : count

      commit('setState', {
        list: list.map((val, i) => {
          return {
            ...val,
            index: i + 1 + (index - 1) * pageSize * 1,
          }
        }),

        pagination: {
          ...state.pagination,
          pageCount: count,
          total,
          pageIndex: index,
        },
      })

      if (count !== 0 && count < pageIndex) {
        return dispatch('getList')
      }
    }

    return res
  },
  /**
   * 删除登录日志
   * @param {*} store
   */
  async deletesLoginLog ({ state, dispatch }) {
    const params = {
      beginTime: state.search.beginTime,
      endTime: state.search.endTime,
      realname: state.search.realname,
    }
    const res = await deletesLoginLog(params)
    if (res.code === 'success') {
      dispatch('getList')
    }
    return res
  },
}

export const loginLog = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default loginLog
